// assets
import FileSearchOutlined from '@ant-design/icons/FileSearchOutlined';
import ShopOutlined from '@ant-design/icons/ShopOutlined';
import TeamOutlined from '@ant-design/icons/TeamOutlined';
import WalletOutlined from '@ant-design/icons/WalletOutlined';

// icons
const icons = { FileSearchOutlined, ShopOutlined, TeamOutlined, WalletOutlined };

// ==============================|| MENU ITEMS - TRADE ||============================== //

const procurement = {
  id: 'group-procurement',
  title: 'Trade',
  type: 'group',
  children: [
    {
      id: 'marketplace',
      title: 'Marketplace',
      type: 'item',
      url: '/marketplace',
      icon: icons.ShopOutlined,
      breadcrumbs: false
    },
    {
      id: 'procurement',
      title: 'Procurement (RFQs)',
      type: 'item',
      url: '/procurement',
      icon: icons.FileSearchOutlined,
      breadcrumbs: false
    },
    {
      id: 'suppliers',
      title: 'Suppliers',
      type: 'item',
      url: '/suppliers',
      icon: icons.TeamOutlined,
      breadcrumbs: false
    },
    {
      id: 'payments',
      title: 'Payments',
      type: 'item',
      url: '/payments',
      icon: icons.WalletOutlined,
      breadcrumbs: false
    }
  ]
};

export default procurement;
